var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClauseCheckSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_700_502",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 11,
    width: 18,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 18,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_700_502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.025 14.4875V19.4581V19.4375V27.6875V14.4875ZM15.025 29.3375C14.5712 29.3375 14.1828 29.1759 13.8597 28.8528C13.5366 28.5297 13.375 28.1413 13.375 27.6875V14.4875C13.375 14.0338 13.5366 13.6453 13.8597 13.3222C14.1828 12.9991 14.5712 12.8375 15.025 12.8375H21.625L26.575 17.7875V19.85C26.3138 19.74 26.0456 19.6541 25.7706 19.5922C25.4956 19.5303 25.2137 19.4856 24.925 19.4581V18.6125H20.8V14.4875H15.025V27.6875H19.9956C20.2156 28.0175 20.4631 28.3234 20.7381 28.6053C21.0131 28.8872 21.3156 29.1313 21.6456 29.3375H15.025ZM24.5125 26.8625C25.09 26.8625 25.5781 26.6631 25.9769 26.2644C26.3756 25.8656 26.575 25.3775 26.575 24.8C26.575 24.2225 26.3756 23.7344 25.9769 23.3356C25.5781 22.9369 25.09 22.7375 24.5125 22.7375C23.935 22.7375 23.4469 22.9369 23.0481 23.3356C22.6494 23.7344 22.45 24.2225 22.45 24.8C22.45 25.3775 22.6494 25.8656 23.0481 26.2644C23.4469 26.6631 23.935 26.8625 24.5125 26.8625ZM28.72 30.1625L26.4925 27.935C26.2038 28.1275 25.8909 28.2719 25.5541 28.3681C25.2172 28.4644 24.87 28.5125 24.5125 28.5125C23.4812 28.5125 22.6047 28.1516 21.8828 27.4297C21.1609 26.7078 20.8 25.8313 20.8 24.8C20.8 23.7688 21.1609 22.8922 21.8828 22.1703C22.6047 21.4484 23.4812 21.0875 24.5125 21.0875C25.5437 21.0875 26.4203 21.4484 27.1422 22.1703C27.8641 22.8922 28.225 23.7688 28.225 24.8C28.225 25.1575 28.1769 25.5047 28.0806 25.8416C27.9844 26.1784 27.84 26.4913 27.6475 26.78L29.875 29.0075L28.72 30.1625Z",
    fill: "#3474E0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClauseCheckSelected);
export default __webpack_public_path__ + "static/media/clause_check_selected.4dae9750aa274e5e99870faf6fa4c8dd.svg";
export { ForwardRef as ReactComponent };